<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('common_words.farm_location') }}
    </p>
    <hr />
    <select-address
      ref="selectAddress"
      :requiredFields="requireAddress"
      @showHideLoading="showHideLoading"
      @onChange="handleChangeSelected"
    />
    <div class="row">
      <div class="col-12 col-sm-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="form-group has-label">
          <label
            >{{ $t('common_words.zone') }}:
            <a
              v-tooltip.top-center="$t('common_words.zone_creation')"
              class="btn-info btn-simple btn-link custom-margin-actions custom-icon-size"
              @click.prevent="openModal('zone_creation')"
            >
              <em class="fa fa-pencil-square-o"></em>
            </a>
          </label>
          <el-select
            clearable
            id="zona"
            filterable
            class="select-primary custom-width-select shadow-sm"
            v-model="model.zone_id"
            size="large"
            :placeholder="`${$t('common_words.select')}...`"
            @change="getSubzone"
          >
            <el-option
              v-for="option in zones"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
        <div class="form-group has-label">
          <label
            >{{ $t('common_words.subzone') }}:
            <a
              v-tooltip.top-center="$t('common_words.subzone_creation')"
              class="btn-info btn-simple btn-link custom-margin-actions custom-icon-size"
              @click.prevent="openModal('subzone_creation')"
            >
              <em class="fa fa-pencil-square-o"></em>
            </a>
          </label>
          <el-select
            clearable
            id="subzona"
            filterable
            class="select-primary custom-width-select shadow-sm"
            v-model="model.subzone_id"
            size="large"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in subzonesByZone"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-4">
        <fg-input
          ref="lat"
          type="text"
          name="common_words.latitude"
          :label="`${$t('common_words.latitude')}: `"
          @change="validateNumber"
          v-model="model.latitude"
          v-validate="'decimal'"
          :error="getError('common_words.latitude', true)"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          ref="long"
          type="text"
          name="common_words.longitude"
          :label="`${$t('common_words.longitude')}: `"
          @change="validateNumber"
          v-model="model.longitude"
          v-validate="'decimal'"
          :error="getError('common_words.longitude', true)"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          ref="altitude"
          type="text"
          name="common_words.altitude"
          :label="`${$t('common_words.altitud_msmn')}: `"
          @change="validateNumber"
          v-model="model.altitude"
          v-validate="'decimal'"
          :error="getError('common_words.altitude', true)"
          v-on:change="geoMap"
        ></fg-input>
      </div>
      <div class="col-12">
        <div class="form-group has-label mt-4">
          <div
            id="arcgis-map"
            ref="map"
            class="map"
            v-if="renderComponent"
          ></div>
          <div
            id="toolbarDiv"
            class="esri-component esri-widget"
            v-if="renderComponent"
          >
            <button
              id="distance"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
              style="margin-bottom: 10px"
              :title="$t('common_words.distance_measurement_tool')"
            ></button>
            <button
              id="area"
              class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
              style="margin-bottom: 10px"
              :title="$t('common_words.area_measurement_tool')"
            ></button>
            <button
              id="clear"
              class="action-button esri-widget--button esri-interactive esri-icon-trash"
              style="margin-bottom: 10px"
              :title="$t('common_words.clear_measurement')"
            ></button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="perimeter"
            :data="uploadData"
            ref="uploadPerimeter"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemovePerimeter"
            :on-exceed="handleExceed"
            :on-success="handleSuccessPerimeter"
            :before-upload="beforeUploadPerimeter"
            :file-list="model.listFiles.Perimetro"
          >
            <el-button size="small" type="primary">{{
              $t('common_words.perimeter')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="block"
            :data="uploadData"
            ref="uploadBlock"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemoveBlock"
            :on-exceed="handleExceed"
            :on-success="handleSuccessBlock"
            :before-upload="beforeUploadBlock"
            :file-list="model.listFiles.Bloques"
          >
            <el-button size="small" type="primary">{{
              $t('common_words.blocks')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="lot"
            :data="uploadData"
            ref="uploadLot"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemoveLot"
            :on-exceed="handleExceed"
            :on-success="handleSuccessLot"
            :before-upload="beforeUploadLot"
            :file-list="model.listFiles.Lotes"
          >
            <el-button size="small" type="primary">{{
              $t('common_words.allotments')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="sewerSystem"
            :data="uploadData"
            ref="uploadSewerSystem"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemoveSewerSystem"
            :on-exceed="handleExceed"
            :on-success="handleSuccessSewerSystem"
            :before-upload="beforeUploadSewerSystem"
            :file-list="model.listFiles.Drenaje"
          >
            <el-button size="small" type="primary">{{
              $t('common_words.drains')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="floor"
            :data="uploadData"
            ref="uploadFloor"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemoveFloor"
            :on-exceed="handleExceed"
            :on-success="handleSuccessFloor"
            :before-upload="beforeUploadFloor"
            :file-list="model.listFiles.Suelo"
          >
            <el-button size="small" type="primary">{{
              $t('samples.ground')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="cableWay"
            :data="uploadData"
            ref="uploadCableWay"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemoveCableWay"
            :on-exceed="handleExceed"
            :on-success="handleSuccessCableWay"
            :before-upload="beforeUploadCableWay"
            :file-list="model.listFiles.CableVia"
          >
            <el-button size="small" type="primary">{{
              $t('common_words.cablecar')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="reservoirs"
            :data="uploadData"
            ref="uploadReservoirs"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemoveReservoirs"
            :on-exceed="handleExceed"
            :on-success="handleSuccessReservoirs"
            :before-upload="beforeUploadReservoirs"
            :file-list="model.listFiles.Reservorio"
          >
            <el-button size="small" type="primary">{{
              $t('common_words.reservoir')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2">
        <div class="form-group has-label">
          <el-upload
            id="buildings"
            :data="uploadData"
            ref="uploadBuildings"
            :headers="headerInfo"
            class="upload-demo custom-upload"
            :action="getAxiosURL() + '/auth/farms/farms/uploadkml'"
            multiple
            :limit="1"
            :on-remove="handleRemoveBuildings"
            :on-exceed="handleExceed"
            :on-success="handleSuccessBuildings"
            :before-upload="beforeUploadBuildings"
            :file-list="model.listFiles.Construcciones"
          >
            <el-button size="small" type="primary">{{
              $t('common_words.constructions')
            }}</el-button>
          </el-upload>
        </div>
      </div>
      <div class="col-12">
        <div slot="tip" class="el-upload__tip text-muted">
          {{ $t('common_words.kml_format_notice') }}
        </div>
      </div>
    </div>
    <ZoneForm
      v-if="zone_creation"
      :key="zoneFormKey"
      :zoneCreation="zone_creation"
      @update:zoneCreation="handleZoneClose"
      :titleModal="titleModal"
      @zonesUpdate="zonesUpdate"
    />
    <SubzoneForm
      v-if="subzone_creation"
      :key="subzoneFormKey"
      :subzoneCreation="subzone_creation"
      @update:subzoneCreation="handleSubzoneClose"
      :titleModal="titleModal"
      @subzonesUpdate="subzonesUpdate"
    />
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { LINK_MAPS, isset, AXIOS_URL } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import axios from 'axios';
import FarmService from 'src/class/FarmService.js';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import optionsAddress from 'src/util/optionsAddress';
import SubzoneForm from 'src/views/Pages/Dashboard/Farm/steps/Forms/SubzoneForm.vue';
import SweetAlert from 'src/class/Alerts';
import ZoneForm from 'src/views/Pages/Dashboard/Farm/steps/Forms/ZoneForm.vue';

export default {
  components: {
    ZoneForm,
    SubzoneForm,
  },
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      // kmlLayer: null,
      // map: null,
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      model: {
        zip_code: null,
        zone_id: null,
        zone_name: null,
        subzone_id: null,
        subzone_name: null,
        id: null,
        address: null,
        latitude: null,
        longitude: null,
        altitude: null,
        country: null,
        city: null,
        state: null,
        other_values: [],
        listFiles: {
          Perimetro: [],
          Bloques: [],
          Lotes: [],
          Drenaje: [],
          Suelo: [],
          CableVia: [],
          Reservorio: [],
          Construcciones: [],
        },
      },
      zones: null,
      renderComponent: true,
      subzones: null,
      states: null,
      cities: null,
      countries: null,
      uploadData: {
        user: this.$store.state.auth.user.id,
        nameFile: '',
      },
      filesKML: [
        'Perimetro',
        'Bloques',
        'Lotes',
        'Drenaje',
        'Suelo',
        'CableVia',
        'Reservorio',
        'Construcciones',
      ],
      requireAddress: true,
      titleModal: '',
      zone_creation: false,
      zoneFormKey: 0,
      subzone_creation: false,
      subzoneFormKey: 0,
    };
  },
  mixins: [
    MixinAlert,
    MixinArcgisMap,
    MixinExport,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
  ],
  computed: {
    subzonesByZone() {
      if (!this.model.zone_id) {
        this.$set(this.model, 'subzone_id', null);

        return [];
      }
      const zone = this.zones.find((z) => z.id === this.model.zone_id);
      if (isset(zone.subzones)) {
        if (isset(this.model.subzone_id)) {
          const subzone = zone.subzones.find(
            (s) => s.id === this.model.subzone_id
          );
          if (!isset(subzone)) this.$set(this.model, 'subzone_id', null);
        }

        return zone.subzones;
      }
      this.$set(this.model, 'subzone_id', null);

      return [];
    },
  },
  methods: {
    getAxiosURL() {
      return AXIOS_URL;
    },
    openModal(name) {
      if (name == 'zone_creation') {
        this.titleModal = i18n.t('common_words.zone_creation');
        this.zone_creation = true;
      }

      if (name == 'subzone_creation') {
        this.titleModal = i18n.t('common_words.subzone_creation');
        this.subzone_creation = true;
      }
    },
    zonesUpdate(zonesUpdate) {
      this.zones = zonesUpdate;
      const existZone = this.zones.find(
        (zone) => zone.id == this.model.zone_id
      );
      if (isset(this.model.zone_id)) {
        if (!isset(existZone)) {
          this.$set(this.model, 'zone', null);
        }
      }
    },
    subzonesUpdate(subzonesUpdate) {
      this.showHideLoading(true);
      Axios.getMasters('zones')
        .then((response) => {
          this.zones = response.data.data;
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
      this.subzones = subzonesUpdate;
      const existSubzone = this.subzones.find(
        (subzone) => subzone.id == this.model.subzone_id
      );
      if (isset(this.model.subzone_id)) {
        if (!isset(existSubzone)) {
          this.$set(this.model, 'subzone', null);
        }
      }
      this.showHideLoading();
    },
    handleZoneClose(val) {
      this.zone_creation = val;
      if (!val) {
        this.zoneFormKey++;
      }
    },
    handleSubzoneClose(val) {
      this.subzone_creation = val;
      if (!val) {
        this.subzoneFormKey++;
      }
    },
    getNameOfData(dataId, options) {
      let dataName = '';
      dataName = options.find((item) => item.id === dataId);

      return dataName ? dataName.name : '';
    },
    validateNumber($text) {
      let regex = /^-?[0-9]\d*([.|,]\d+)?$/;
      if ($text.target.value.match(regex) == null) {
        switch ($text.target.name) {
          case 'latitud':
            this.model.latitude = null;
            break;

          case 'longitud':
            this.model.longitude = null;
            break;

          case 'altitud':
            this.model.altitude = null;
            break;

          default:
            break;
        }
      }
    },

    handleRemovePerimeter(file) {
      this.uploadData.nameFile = this.filesKML[0];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[0]
      );
      this.removeFileUpload(1, file);
    },

    handleRemoveBlock(file) {
      this.uploadData.nameFile = this.filesKML[1];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[1]
      );
      this.removeFileUpload(2, file);
    },

    handleRemoveLot(file) {
      this.uploadData.nameFile = this.filesKML[2];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[2]
      );
      this.removeFileUpload(3, file);
    },

    handleRemoveSewerSystem(file) {
      this.uploadData.nameFile = this.filesKML[3];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[3]
      );
      this.removeFileUpload(4, file);
    },

    handleRemoveFloor(file) {
      this.uploadData.nameFile = this.filesKML[4];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[4]
      );
      this.removeFileUpload(5, file);
    },

    handleRemoveCableWay(file) {
      this.uploadData.nameFile = this.filesKML[5];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[5]
      );
      this.removeFileUpload(6, file);
    },

    handleRemoveReservoirs(file) {
      this.uploadData.nameFile = this.filesKML[6];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[6]
      );
      this.removeFileUpload(7, file);
    },

    handleRemoveBuildings(file) {
      this.uploadData.nameFile = this.filesKML[7];
      this.model.other_values = this.model.other_values.filter(
        (item) => item !== this.filesKML[7]
      );
      this.removeFileUpload(8, file);
    },

    removeFileUpload(option, file) {
      this.showHideLoading(true);
      axios
        .post('/auth/farms/farms/deletekml', {
          name: file.name,
          nameFile: this.uploadData.nameFile,
          user: this.uploadData.user,
        })
        .then(() => {
          this.showHideLoading();
          this.model.listFiles[this.filesKML[option - 1]] = [];
          localStorage.setItem(
            'listFiles',
            JSON.stringify(this.model.listFiles)
          );
          this.loadMap();
        });
    },

    handleExceed(files) {
      SweetAlert.warning(
        ` ${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')} `
      );
    },

    handleSuccessPerimeter(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[0]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[0]);
      this.loadMap();
    },

    handleSuccessBlock(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[1]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[1]);
      this.loadMap();
    },

    handleSuccessLot(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[2]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[2]);
      this.loadMap();
    },

    handleSuccessSewerSystem(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[3]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[3]);
      this.loadMap();
    },

    handleSuccessFloor(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[4]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[4]);
      this.loadMap();
    },

    handleSuccessCableWay(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[5]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[5]);
      this.loadMap();
    },

    handleSuccessReservoirs(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[6]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[6]);
      this.loadMap();
    },

    handleSuccessBuildings(_, file) {
      file.editFile = true;
      this.model.listFiles[this.filesKML[7]].push(file);
      localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
      this.model.other_values.push(this.filesKML[7]);
      this.loadMap();
    },

    beforeUploadPerimeter(file) {
      this.uploadData.nameFile = this.filesKML[0];

      return this.verifyUpload(1, file);
    },

    beforeUploadBlock(file) {
      this.uploadData.nameFile = this.filesKML[1];

      return this.verifyUpload(2, file);
    },

    beforeUploadLot(file) {
      this.uploadData.nameFile = this.filesKML[2];

      return this.verifyUpload(3, file);
    },

    beforeUploadSewerSystem(file) {
      this.uploadData.nameFile = this.filesKML[3];

      return this.verifyUpload(4, file);
    },

    beforeUploadFloor(file) {
      this.uploadData.nameFile = this.filesKML[4];

      return this.verifyUpload(5, file);
    },

    beforeUploadCableWay(file) {
      this.uploadData.nameFile = this.filesKML[5];

      return this.verifyUpload(6, file);
    },

    beforeUploadReservoirs(file) {
      this.uploadData.nameFile = this.filesKML[6];

      return this.verifyUpload(7, file);
    },

    beforeUploadBuildings(file) {
      this.uploadData.nameFile = this.filesKML[7];

      return this.verifyUpload(8, file);
    },

    verifyUpload(option, file) {
      this.showHideLoading(true);
      const isKML = file.name.includes('.kml');
      //const isJPG = file.type === 'image/jpeg';
      //const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isKML) {
        SweetAlert.warning('error');
        this.model.listFiles[this.filesKML[option - 1]] = [];
        localStorage.setItem('listFiles', JSON.stringify(this.model.listFiles));
        this.showHideLoading();
      }
      /*if (!isLt2M) {
        this.$message.error('La imagen excede los 2MB!');
      }*/
      return isKML; //&& isLt2M;
    },

    getSubzone() {
      Axios.getMasters(`zones/getSubzones/${this.model.zone_id}`)
        .then((response) => {
          this.subzones = response.data.data;
        })
        .catch(() => {});
    },

    geoMap($event) {
      if ($event != undefined) {
        let regex = /^-?[0-9]\d*([.|,]\d+)?$/;
        if ($event.target.value.match(regex) == null) {
          switch ($event.target.classList) {
            case 'latitud':
              this.model.latitude = null;
              break;

            case 'longitud':
              this.model.longitude = null;
              break;

            case 'altitud':
              this.model.altitude = null;
              break;

            default:
              break;
          }
        }
      }

      this.center.lat = this.model.latitude
        ? parseFloat(this.model.latitude)
        : this.center.lat;
      this.center.lng = this.model.longitude
        ? parseFloat(this.model.longitude)
        : this.center.lng;

      this.loadMap();
    },

    async loadMap() {
      this.renderComponent = false;
      const namesFiles = await FarmService.map(
        this.model,
        this.uploadData.user,
        false
      );

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadMapMultipleC(namesFiles, true);
        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 23%;right: 30px';
        }, 10);
        if (!sessionStorage.getItem('showLoading')) this.showHideLoading();
        else sessionStorage.removeItem('showLoading');
      });
    },

    validate() {
      return this.$validator.validateAll().then((response) => {
        if (!response) return false;

        if (!this.requireAddress) {
          this.model.zone_name = this.getNameOfData(
            this.model.zone_id,
            this.zones
          );
          this.model.subzone_name = this.getNameOfData(
            this.model.subzone_id,
            this.subzones
          );
          this.$emit('on-validated', this.model);

          return true;
        }

        return new Promise((resolve) => {
          this.$refs.selectAddress.$emit('validateAddress', (isValid) => {
            if (isValid) {
              this.model.zone_name = this.getNameOfData(
                this.model.zone_id,
                this.zones
              );
              this.model.subzone_name = this.getNameOfData(
                this.model.subzone_id,
                this.subzones
              );
              this.$emit('on-validated', this.model);
            }

            resolve(isValid);
          });
        });
      });
    },

    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
  },

  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('zones'), Axios.getMasters('subzone')])
        .then(([responseZones, responseSubzones]) => {
          this.zones = responseZones.data.data;
          this.subzones = responseSubzones.data.data;
          let editForm = {};
          editForm = JSON.parse(sessionStorage.getItem('editForm'));
          if (this.isUpdate() && editForm) {
            this.model.id = editForm.id;
            this.model.zip_code = editForm.zip_code;
            this.model.address = editForm.address;
            this.model.latitude = editForm.latitude.replace(',', '.');
            this.model.longitude = editForm.longitude.replace(',', '.');
            this.model.altitude = editForm.altitude.replace(',', '.');
            this.model.country = editForm.country;
            this.model.state = editForm.state;
            this.model.city = editForm.city;
            this.model.zone_id = editForm.zone_id;
            this.model.subzone_id = editForm.subzone_id;

            if (
              editForm.other_values &&
              JSON.parse(editForm.other_values).files
            ) {
              this.model.other_values = JSON.parse(editForm.other_values).files;

              JSON.parse(editForm.other_values).files.forEach((element) => {
                let url = LINK_MAPS + this.model.id + '/' + element + '.kml';

                this.createFile({
                  url: url,
                  name: element,
                  extension: 'kml',
                }).then((res) => {
                  let file = {
                    editFile: false,
                    lastModified: res.lastModified,
                    lastModifiedDate: res.lastModifiedDate,
                    name: res.name,
                    size: res.size,
                    status: res.status,
                    type: res.type,
                    uid: res.uid,
                    webkitRelativePath: res.webkitRelativePath,
                  };

                  if (element == this.filesKML[0])
                    this.model.listFiles[this.filesKML[0]].push(file);
                  else if (element == this.filesKML[1])
                    this.model.listFiles[this.filesKML[1]].push(file);
                  else if (element == this.filesKML[2])
                    this.model.listFiles[this.filesKML[2]].push(file);
                  else if (element == this.filesKML[3])
                    this.model.listFiles[this.filesKML[3]].push(file);
                  else if (element == this.filesKML[4])
                    this.model.listFiles[this.filesKML[4]].push(file);
                  else if (element == this.filesKML[5])
                    this.model.listFiles[this.filesKML[5]].push(file);
                  else if (element == this.filesKML[6])
                    this.model.listFiles[this.filesKML[6]].push(file);
                  else if (element == this.filesKML[7])
                    this.model.listFiles[this.filesKML[7]].push(file);

                  localStorage.setItem(
                    'listFiles',
                    JSON.stringify(this.model.listFiles)
                  );
                });
              });

              setTimeout(() => {
                this.geoMap();
              }, 1000);
            } else {
              this.geoMap();
            }
          } else {
            this.geoMap();
          }
          sessionStorage.setItem('showLoading', 'false');
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },

  destroyed() {
    localStorage.removeItem('listFiles');
  },
};
</script>
<style>
#arcgis-map {
  height: 600px;
}

@media (min-width: 1700px) {
  #arcgis-map {
    height: 80vh;
  }
}
</style>
